import axios from "axios"
import { mapKeys, mapValues, camelCase, snakeCase } from "lodash"
import { TokenService } from "@/service/Storage.Service.js"
import qs from "qs"

const { VUE_APP_API_URL, VUE_APP_XAUTH, VUE_APP_API_MASTER, VUE_APP_XAUTH_MASTER } = process.env

function getAccessToken() {
  // @todo: load access token from cookie or locale storage
  return TokenService.getToken()
}

function transformKeys(data, iteratee) {
  if (Array.isArray(data)) {
    return data.map((d) => transformKeys(d, iteratee))
  }

  if (data instanceof Object) {
    return mapValues(
      mapKeys(data, (_, k) => iteratee(k)),
      (v) => transformKeys(v, iteratee)
    )
  }

  return data;
}

export function camelCaseKeys(data) {
  return transformKeys(data, camelCase)
}

export function snakeCaseKeys(data) {
  return transformKeys(data, snakeCase)
}

// @see: https://github.com/mzabriskie/axios#axios-api
export function request(method, url, config = {}, options = {}) {
  const {
    params,
    data,
    headers,
    maxContentLength
  } = config;

  // non-axios specific params
  const {
    suppressAuth
  } = options;

  const baseURL = url.split('/')[0] !== 'location' && url.split('/')[0] !== 'region' && url.split('/')[0] !== 'organisasi_dinas' ? VUE_APP_API_URL : VUE_APP_API_MASTER
  const xauth = url.split('/')[0] !== 'location' && url.split('/')[0] !== 'region' && url.split('/')[0] !== 'organisasi_dinas' ? VUE_APP_XAUTH : VUE_APP_XAUTH_MASTER

  // @see: https://tools.ietf.org/html/rfc6750
  const bearerToken = getAccessToken()

  return new Promise((resolve, reject) => {
    axios.defaults.paramsSerializer = function(params) {
      return qs.stringify(params)
    }

    axios({
      method,
      baseURL,
      url,
      params,
      data: data,
      headers: suppressAuth ? headers : { ...headers, Authorization: xauth, token: bearerToken, Accept: 'application/json', 'Content-Type': 'application/json' },
      maxContentLength
    })
    .then((response) => {
      resolve({
        ...response,
        data: response.data
      })
      
      // const code = response.data.status, message = response.data.error_code
      
      // if (code === 200) {
      //   resolve({
      //     ...response,
      //     data: response.data
      //   })
      // }

      // if (code === 400) {
      //   window.location = '/'
      // }
  
      // if (code === 401 ) {
      //   if (message !== undefined) {
      //     console.log('unauthorized, logging out ...')
      //     TokenService.removeToken()
      //     window.location = '/'
      //   }
      // }
  
      // if (code === 500) {
      //   window.location = '/'
      // }
    })
    .catch((error) => {
      // Do something with response error
      if (error.response.status === 401) {
        console.log('unauthorized, logging out ...')
        TokenService.removeToken()
        window.location = '/'
      }
      return Promise.reject(error.response)
    })
  })
}

export function get(url, config, options) {
  return request("GET", url, config, options)
}

export function post(url, config, options) {
  return request("POST", url, config, options)
}

export function put(url, config, options) {
  return request("PUT", url, config, options)
}

export function patch(url, config, options) {
  return request("PATCH", url, config, options)
}

export function destroy(url, config, options) {
  return request("DELETE", url, config, options)
}